export function paymentStatus(status) {
  const value = String(status || '').trim().toLowerCase().replace(/[ -]/g, '_');
  if (['success', 'successful', 'payment_success'].includes(value)) return 'success';
  if (value === 'pending') return 'pending';
  if (['failed', 'failure', 'cancelled', 'canceled', 'rejected', 'expired'].includes(value)) return 'failed';
  return 'unknown';
}
